import styled from 'styled-components';

export const TooltipStyled = styled.div<{
  isDown?: boolean;
  canBreak?: boolean;
}>`
  padding: 6px 10px;
  max-width: ${(p) => (p.canBreak ? '304px' : 'unset')};
  position: absolute;
  bottom: ${(p) => (p.isDown ? 'unset' : 'calc(100% + 6px)')};
  top: ${(p) => (p.isDown ? 'calc(100% + 6px)' : 'unset')};
  left: 50%;
  transform: translateX(-50%);
  background: ${(p) => p.theme.colors.blue.dark};
  border-radius: 4px;
  color: ${(p) => p.theme.colors.white};
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  white-space: ${(p) => (p.canBreak ? 'normal' : 'nowrap')};
`;
